import {
  HANDLE_APPLINK,
  HANDLE_DEEP_LINK,
  HANDLE_DEEP_LINK_NAVIGATION,
  SET_DEEP_LINK_PARAMS,
} from "../reducers/actionTypes";

export const handleDeepLink = (params) => ({
  type: HANDLE_DEEP_LINK,
  params,
});

export const handleDeepLinkNavigation = (params) => ({
  type: HANDLE_DEEP_LINK_NAVIGATION,
  params,
});

export const setDeepLinkParams = (params) => ({
  type: SET_DEEP_LINK_PARAMS,
  params,
});

export const setAppLinkClickId = (payload) => ({
  type: "SET_APP_LINK_CLICK_ID",
  payload,
});

export const setReferer = (payload) => ({
  type: "SET_REFERER",
  payload,
});

export const setRefererSuccess = () => ({
  type: "SET_REFERER_SUCCESS",
});

export const setHashResult = (payload) => ({
  type: "SET_HASH_RESULT",
  payload,
});

export const handleAppLink = (payload) => ({
  type: HANDLE_APPLINK,
  payload,
});
